import type { SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ReportDashboardComponent,
  ReportDashboardComponentChartType,
  ReportDashboardComponentKind,
} from '@core/reports-types';
import type { IconName } from '@core/user-interface-legacy';
import { RtTooltip, IconComponent, keyIconMap } from '@core/user-interface-legacy';
export interface ChartTypeOption {
  label: string;
  value: ReportDashboardComponentChartType;
  disabled?: boolean;
}

@Component({
  selector: 'reports-chart-type-selector',
  templateUrl: './chart-type-selector.component.html',
  styleUrls: ['./chart-type-selector.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RtTooltip, IconComponent, TranslatePipe],
})
export class ReportsChartTypeSelectorComponent {
  public readonly chartType = input<ChartTypeOption>(undefined!);
  public readonly component = input<ReportDashboardComponent>(undefined!);

  public chartTypeSelected = output<ChartTypeOption>();

  public iconName: IconName;
  public tooltipValue: string;

  private iconMapping = keyIconMap({
    [ReportDashboardComponentChartType.Bar]: 'chart-icon_bar',
    [ReportDashboardComponentChartType.Line]: 'chart-icon_line',
    [ReportDashboardComponentChartType.Pie]: 'chart-icon_pie',
    [ReportDashboardComponentChartType.Column]: 'chart-icon_column',
  });

  private labelMapping = {
    [ReportDashboardComponentChartType.Bar]: 'tlr.component_builder_dialog.chart_types.bar',
    [ReportDashboardComponentChartType.Column]: 'tlr.component_builder_dialog.chart_types.column',
    [ReportDashboardComponentChartType.Line]: 'tlr.component_builder_dialog.chart_types.line',
    [ReportDashboardComponentChartType.Pie]: 'tlr.component_builder_dialog.chart_types.pie',
  };

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.chartType || changes.component || changes.stacked) {
      this.iconName = this.iconMapping[this.chartType().value];

      const chartType = this.chartType();
      const component = this.component();
      if (
        component.kind === ReportDashboardComponentKind.Breakdown &&
        chartType.value === ReportDashboardComponentChartType.Bar &&
        component.primaryGroup &&
        component.secondaryGroup
      ) {
        this.iconName += '-stacked';
      }

      if (
        component.kind === ReportDashboardComponentKind.Trend &&
        chartType.value === ReportDashboardComponentChartType.Column &&
        component.primaryGroup
      ) {
        this.iconName += '-stacked';
      }

      this.tooltipValue = this.labelMapping[chartType.value];
    }
  }
}
